import { vetter } from '@vette/pages';

export default vetter.LoginPage;
